import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { confirmPayee } from 'services/BeneficiaryService'
import { ConfirmPayeeRequest } from 'types/payoutsV2'

export interface ConfirmPayeeProps {
  request: ConfirmPayeeRequest
  enabled: boolean
}

export const useConfirmPayee = ({ request, enabled }: ConfirmPayeeProps) => {
  return useQuery({
    queryKey: reactQueryKeys.confirmPayee(request),
    queryFn: () => confirmPayee(request),
    enabled: enabled,
  })
}
